// extracted by mini-css-extract-plugin
export var fadeIn = "_i2-1";
export var modalContent = "_i2-3";
export var overlay = "_i2-0";
export var popoverContent = "_i2-2";
export var results = "_i2-5";
export var searchInputWrapper = "_i2-4";